<template>
  <div>
    <div
      v-if="articles[0].image"
      id="banner"
      class="uk-height-small uk-flex uk-flex-center uk-flex-middle uk-background-cover uk-light uk-padding"
      :data-src="api_url + articles[0].image.url"
      uk-img
    >
    <div id="overlay">
      <h1>{{ articles[0].title }}</h1>
    </div>
    </div>
    
    <div class="uk-section">
      <div class="uk-container uk-container-small">
        <h3>
            {{ articles[0].author.firstname }} "{{ articles[0].author.username }}" {{ articles[0].author.lastname }}
            // {{ moment(articles[0].published_at).format("DD.MM.YYYY") }} KL. {{ moment(articles[0].published_at).format("HH:II:SS") }}
        </h3>
        <p class="excerpt">
          {{ articles[0].excerpt }}
        </p>
        <vue-markdown-it
          v-if="articles[0].article"
          :source="articles[0].article"
          id="editor"
        />
        <h3>Kommentarer (4)</h3>
        <div v-for="comment in articles[0].comments" v-bind:key="comment.id" class="commentContainer">
          <div class="meta">
            <strong class="big">{{ comment.author.username }}</strong><br>
            <strong class="red">#{{ comment.id }}</strong> {{ moment(comment.updated_at).format("DD.MM.YYYY") }} {{ moment(comment.updated_at).format("HH:II:SS") }}
          </div>
          <div class="comment">
            {{ comment.comment }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
.excerpt {
  font-size: 150%;
  font-weight: bold;
}
#banner {
  padding: 0!important;
  margin: 0!important;
}
#overlay {
  background-color: rgba(0, 0, 0, 0.7) !important;
  width: 100%;
  height: 100%;
}
h1 {
  text-align: center;
  padding-top: 320px;
}

.commentContainer {
  width: 100%;
  min-height: 66px;
  margin-bottom: 15px;
}
.meta {
  width: 116px;
  float: left;
  text-align: right;
  color: white;
  margin-right: 12px;
  font-size: 12px;
  padding-top: 10px;
}
.big {
  font-size: 17.5px;
  text-transform: uppercase;
}
.red {
  color: #ff4655;
}
.comment {
  width: 742px;
  min-height: 46px;
  padding: 10px;
  float: left;
  background-color: #FFF;
  color: #0f1923;
}
</style>

<script>
var moment = require("moment");
import VueMarkdownIt from "vue-markdown-it";
import gql from "graphql-tag";

export default {
  data() {
    return {
      articles: {},
      moment: moment,
      api_url: process.env.VUE_APP_STRAPI_API_URL,
      routeParam: this.$route.params.id
    };
  },
  name: "Article",
  components: {
    VueMarkdownIt
  },
  apollo: {
    articles: {
      query: gql`
        query Articles($slug: String!) {
            articles(where: { slug: $slug }) {
                slug
                title
                image {
                    url
                }
                author {
                    id
                    firstname
                    lastname
                    username
                }
                excerpt
                article
                published_at
                last_edited_date
                comments(sort: "id:asc") {
                  id
                  author {
                    username
                  }
                  comment
                  updated_at
                }
            }
        }
      `,
      variables() {
          console.log('Test:' + this.routeParam)
        return {
          slug: this.routeParam
        };
      }
    }
  }
};
</script>